import * as React from 'react';
import { ModelConfigsEditable } from '../../moderationFiltersTypes';
import styles from './ModerationFiltersModels.module.scss';
import classnames from 'classnames';
import Checkbox from '../../../../../../common/inputs/checkbox-input';

interface ModerationFiltersModelsProps {
  onSelectionChange: (model: string) => void;
  onCurrentModelChange: (model: string) => void;
  configs: ModelConfigsEditable;
  currentModel?: string;
}

export function ModerationFiltersModels(props: ModerationFiltersModelsProps) {
  const { currentModel, configs, onSelectionChange, onCurrentModelChange } = props;

  return (
    <ul className={styles.modelsContainer}>
      {Object.entries(configs).map(([model, config]) => {
        const { selected, label } = config;

        return (
          <li
            className={classnames(styles.model, { [styles.selectedModel]: model === currentModel })}
            key={model}
            onClick={() => {
              onCurrentModelChange(model);
            }}
          >
            <Checkbox
              className={styles.checkbox}
              value={selected}
              text={label}
              onlyCheckBoxClick={true}
              onChange={() => {
                onSelectionChange(model);
              }}
            />
          </li>
        );
      })}
    </ul>
  );
}
